export default {
    name: 'count-rest',
	description: 'Заставка',
	title: 'Количество задач',
	minigameType: 'Intro',
	generateParams() {
		return {
            question: "Выберите, сколько задач вам будет предложено в следующем раунде",
			options: [
                'Одна', 'Две', 'Пять', 'Десять', 'Двадцать'
			],
			correct: [1,2]
        };
	},
	isCompleted: () => true,
	messages() {
		return {
			onFinish: () => "Начинаем следующий раунд!",
		};
	},
}